var map = {
	"./10_nuts.png": 2512,
	"./1drink_12beer.png": 2513,
	"./1serving_8ounces.png": 2514,
	"./1serving_8ounces2.png": 2515,
	"./1serving_8ounces3.png": 2516,
	"./1serving_8ounces4.png": 2517,
	"./1serving_8ounces5.png": 2518,
	"./8ounces_1glass.png": 2519,
	"./can_1.png": 2520,
	"./can_2.png": 2521,
	"./can_3.png": 2522,
	"./cup.png": 2523,
	"./dried_serving_1/4cup.png": 2524,
	"./dried_serving_1:4cup.png": 2525,
	"./fresh_serving_1cup.png": 2526,
	"./glass_1.png": 2527,
	"./glass_2.png": 2528,
	"./golfball.png": 2529,
	"./halfthumb.png": 2530,
	"./hand_1.png": 2531,
	"./hand_2.png": 2532,
	"./hand_3.png": 2533,
	"./hand_4.png": 2534,
	"./hand_5.png": 2535,
	"./how.png": 865,
	"./serving_1/2cup.png": 2536,
	"./serving_1:2cup.png": 2537,
	"./serving_1tbsp.png": 2538,
	"./serving_3/4ounces.png": 2539,
	"./serving_3:4ounces.png": 2540,
	"./thumbx2.png": 2541,
	"./usda.png": 2542,
	"./vegetables_1cup.png": 2543,
	"./what.png": 863,
	"./wholethumb.png": 2544,
	"./why.png": 864
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2511;